import React, { useContext, useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { Table, Button, Input } from "antd";
import { useHistory } from "react-router-dom";
import Header from "../components/header/HeaderHome";
import { GlobalContext } from "../hook/GlobalHook";
import { getmatchschoolcourseAction, getSchoolInfoByIdAction } from "../actions";

const { Column } = Table;

export default function SchoolTeacher() {
  const GlobalHook = useContext(GlobalContext);
  const history = useHistory();
  const [courses, setCourses] = useState([]);
  const [courseFilter, setCourseFilter] = useState("");
  const schoolId =
    GlobalHook.getGlobalUser?.schoolTeacherSchoolId ||
    GlobalHook.getGlobalUser?.schoolAdminId;

  useEffect(() => {
    if (!schoolId) {
      history.push("/");
      return;
    }

    getmatchschoolcourseAction(GlobalHook, schoolId);
    getSchoolInfoByIdAction(GlobalHook, schoolId);
  }, [GlobalHook.getGlobalUser]);

  useEffect(() => {
    if (GlobalHook.getGlobalMatchCourseSchool?.length) {
      setCourses(
        GlobalHook.getGlobalMatchCourseSchool.map((course, index) => ({
          key: course._id || index,
          courseId: course._id,
          courseName: course.courseName,
          courseSlug: course.courseSlug,
          cover: course.courseImage,
        }))
      );
    } else {
      setCourses([]);
    }
  }, [GlobalHook.getGlobalMatchCourseSchool]);

  const filteredCourses = useMemo(() => {
    const q = (courseFilter || "").trim().toLowerCase();
    if (!q) return courses;
    return courses.filter((c) =>
      String(c.courseName || "").toLowerCase().includes(q)
    );
  }, [courses, courseFilter]);

  return (
    <>
      <Helmet>
        <title>Studysabai: Teacher</title>
      </Helmet>
      <Header />
      <div className="w-full flex flex-col items-center py-6">
        <div className="w-10/12 rounded-lg text-center text-white py-2 text-2xl font-bold mb-6 bg-orange-500">
          Teacher Dashboard: {GlobalHook.getGlobalSchoolInfo?.schoolName || ""}
        </div>
        <p className="mb-4 text-gray-700">
          Select a course to view student quiz scores and pass/fail results
        </p>
        <div style={{ width: "80%", marginBottom: 16 }}>
          <Input
            allowClear
            placeholder="Filter by course name"
            value={courseFilter}
            onChange={(e) => setCourseFilter(e.target.value)}
          />
        </div>
        <Table dataSource={filteredCourses} style={{ width: "80%" }}>
          <Column title="Course" dataIndex="courseName" key="courseName" />
          <Column
            title="Action"
            key="action"
            render={(text, record) => (
              <Button
                type="primary"
                onClick={() => history.push(`/schoolteacher/${record.courseId}`)}
              >
                Open Dashboard
              </Button>
            )}
          />
        </Table>
      </div>
    </>
  );
}
